<template>
  <delete v-if="onDelete" :dialog="onDelete" :message="'Are you sure you want to delete this template?'" :id="deleteID" :title="'Delete Template'" @onChange="deleteConfirmation" @close="closeConfirmation"/>
  <domain v-if="domainDialog" :dialog="domainDialog" @close="closeDomainDialog" />
  <div>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Phishing</li>
        </ol>
      </nav>


			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-8 col-xs-12">
                    <div class="d-flex flex-row align-items-center">
                      <div class="align-middle p-2 col-5" style="font-size: 14px; position: relative;">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="Search template..." aria-label="Username" v-model="search" aria-describedby="search" style="box-sizing: border-box; width: 331px; height: 40px; border: 1px solid #D9D9D9; border-radius: 20px; padding-left: 40px;">
                          <span class="input-group-addon" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background-color: white;">
                            <i class="fas fa-search"></i>
                          </span>
                        </div>
                      </div>
                      <div class="align-middle p-2 col-lg-7 col-md-7 col-xs-12">
                        <button type="button" class="btn btn-outline-primary btn-create" @click="templateDialog = true;" v-tooltip.top="'Add new Template'">Upload</button>
                        <button type="button" class="ms-3 btn btn-outline-primary btn-create" @click="domainDialog = true;" v-tooltip.top="'Add new Domain'">Domains</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-xs-12">
                    <div class="d-flex flex-row-reverse">
                      <div class="align-middle p-2 col-xs-12">
                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                          <button type="button" class="btn btn-square btn-labeled" :class="view.list ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.list" @click="view.list = !view.list, view.grid = !view.list" v-tooltip.top="'Switch to List View'"><span class="btn-label"><i class="fas fa-list"></i></span></button>
                          <button type="button" class="btn btn-square btn-labeled" :class="view.grid ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.grid" @click="view.grid = !view.grid, view.list = !view.grid" v-tooltip.top="'Switch to Tile View'"><span class="btn-label"><i class="fas fa-border-all"></i></span></button>
                        </div>
                      </div>
                      <div class="col-xs-12 p-3" style="font-size:14px;">
                        <div class="dropdown-toggle text-default" id="sortBy" data-bs-toggle="dropdown" aria-expanded="false">
                          <span> <strong>Sort by: </strong></span>
                          <span class="text-info" style="cursor:pointer;"> {{ selectedSort }} </span>
                          <ul class="dropdown-menu w-25" aria-labelledby="sortBy">
                            <li><span class="dropdown-item" v-for="(item,index) in sortByOptions" :key="index" @click="sortBy = item.value, selectedSort = item.label"> {{item.label}} </span></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="mt-5">
                    <div class="row">

                      <div v-if="loading" class="text-center align-middle">
                        <img src="@/assets/img/loading.svg">
                      </div>

                      <div v-if="templates.length == 0 && !loading" class="text-center">
                        <div class="card-body align-middle text-default" style="margin: auto; width: 50%; padding: 100px;">
                          <h2>No Data</h2>
                        </div>
                      </div>
                      <div v-else>
                        <div class="col-12">
                          <h2>Phishing Templates</h2>
                        </div>
                        <!-- grid view -->
                        <div class="row">
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2" v-for="(item, index) in templates" :key="index">
                            <div class="card-body text-default" v-if="!loading && view.grid" style="padding: 2px;">
                              <div style="position: relative; width: 100%; height: 0; padding-bottom: 56.25%;">
                                <img v-lazy="item.thumbnail" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; box-shadow: 0 0 5px gray;" alt="Template Thumbnail">
                              </div>
                              <div class="pa-0 mt-2">
                                <h6 style="font-size:14px;"><strong>{{ item.name}}</strong></h6>
                                <span><small class="text-muted">Vertex or Client Input: </small><strong style="font-size:14px;">{{ item.template_mapping.input_type ? "Vertex" : "Client" }}</strong></span>
                                <br />
                                <span><small class="text-muted">Client Name: </small> <strong style="font-size:14px;">{{  item.organisation_id == 0 ? "N/A" : "Client" }}</strong></span>
                                <br>
                                <div class="inline-block">
                                  <!-- edit button -->
                                  <button type="button" v-tooltip.top="'Edit Template'" class="btn btn-default btn-circle custom-spacing custom-icon-btn" @click="setTemplate(item)">
                                    <i class="fa fa-pen"></i>
                                  </button>
                                  <!-- delete button -->
                                  <button type="button" class="btn btn-default btn-circle-danger custom-icon-btn custom-spacing" ms-1 v-tooltip.top="'Delete Template'" @click="deleteTemplate(item.ID)">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 4H12C12 3.46957 11.7893 2.96086 11.4142 2.58579C11.0391 2.21071 10.5304 2 10 2C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4ZM6 4C6 2.93913 6.42143 1.92172 7.17157 1.17157C7.92172 0.421427 8.93913 0 10 0C11.0609 0 12.0783 0.421427 12.8284 1.17157C13.5786 1.92172 14 2.93913 14 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5C20 5.26522 19.8946 5.51957 19.7071 5.70711C19.5196 5.89464 19.2652 6 19 6H18.118L17.232 16.34C17.1468 17.3385 16.69 18.2686 15.9519 18.9463C15.2137 19.6241 14.2481 20.0001 13.246 20H6.754C5.75191 20.0001 4.78628 19.6241 4.04815 18.9463C3.31002 18.2686 2.85318 17.3385 2.768 16.34L1.882 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H6ZM13 10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V10ZM8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9Z" fill="#EB1C24"/>
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>



                        <div v-if="!loading && view.list">
                          <!-- list view -->
                          <table class="table">
                            <thead>
                              <tr class="table-light text-default">
                                <th>Template Name</th>
                                <th>Vertex or Client Input</th>
                                <th>Client Name</th>
                                <th>Link to Domain</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle text-default" v-for="(item, index) in templates" :key="index">
                              <tr>
                                  <td> {{ item.name }}</td>
                                  <td>{{ item.template_mapping.input_type ? "Vertex" : "Client"}} </td>
                                  <td>
                                    {{  item.organisation_id == 0 ? "N/A" : "Client"}}
                                  </td>
                                  <td>{{ item.domain }}</td>
                                  <td>
                                    <button type="button" class="btn btn-default btn-circle ms-1" ms-1 v-tooltip.top="'Edit Template'" @click="setTemplate(item)"><i class="far fa-edit"></i></button>
                                    <button type="button" class="btn btn-default btn-circle-danger ms-1" ms-1 v-tooltip.top="'Delete Template'"><i class="fas fa-trash" @click="deleteTemplate(item.ID)"></i></button>
                                  </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
  </div>

  <!-- start phishing dialog -->
<vue-final-modal v-model="templateDialog" classes="modal-container" content-class="modal-content">

  <div class="modal-header justify-content-between">
    <span class="modal__title text-white">Upload Template</span>
    <div>
      <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
    </div>
  </div>

    <div class="modal__body">
      <div class="modal__content mt-3 mb-4">
          <div>
            <div class="col mb-5 mt-3">
              <div class="mb-1">
                <label for="formFile" class="form-label text-default" style="font-size:14px;">Template Name</label>
                <input class="form-control" type="text" placeholder="Name" v-model="template.name">
                <div class="text-danger" v-for="error of v$.template.name.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
              <div v-if="templateDialog">
                <label for="emailContentFile" class="form-label text-default" style="font-size:14px;">Email Content</label>
                <FileUploader ref="emailContentFileRef" :id="'emailContentFile'" @fileListChange="handleEmailFileUpload" key="emailContentFile" :class="{ 'mb-3': v$.template.emailContent.$errors.length == 0 }"/>
                <div class="text-danger" v-for="error of v$.template.emailContent.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
              <div v-if="templateDialog">
                <label for="landingContentFile" class="form-label text-default" style="font-size:14px;">Landing Page</label>
                <FileUploader ref="landingContentFileRef" :id="'landingContentFile'" @fileListChange="handleLandingFileUpload" key="landingContentFile" :class="{ 'mb-3': v$.template.landingContent.$errors.length == 0 }"/>
                <div class="text-danger" v-for="error of v$.template.landingContent.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
              <div v-if="templateDialog">
                <label for="thumbnail" class="form-label text-default" style="font-size:14px;">Thumbnail</label>
                <!-- <ImageUploader ref="thumbnailRef" :id="'thumbnail'" @fileListChange="handleThumbnailFileUpload" key="thumbnail" :acceptedFileType="'png,jpeg'" :class="{ 'mb-3': v$.template.thumbnail.$errors.length == 0 }"/> -->
                <ImageUploader ref="thumbnailRef" :id="'thumbnail'" @fileListChange="handleThumbnailFileUpload" key="thumbnail" :acceptedFileType="'png,jpeg'" :imageFile="thumbnailImageFile" :class="{ 'mb-3': v$.template.thumbnail.$errors.length == 0 }"/>
                <div class="text-danger" v-for="error of v$.template.thumbnail.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
              <div class="mb-1">
                <label for="domainSelect" class="form-label text-default" style="font-size: 14px;">Select Domain</label>
                <select class="form-select" id="domainSelect" v-model="template.linkToDomain">
                  <option value="">Select a domain</option>
                  <option v-for="(domain, index) in domains" :key="index" :value="domain.name">{{ domain.name }}</option>
                </select>
                <div class="text-danger" v-for="error of v$.template.linkToDomain.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
              <div class="mb-1">
                <label for="redirectUrlInput" class="form-label text-default" style="font-size: 14px;">Redirect URL</label>
                <input
                  type="text"
                  id="redirectUrlInput"
                  class="form-control"
                  v-model="template.redirectUrl"
                  placeholder="Enter redirect URL"
                />
                <div class="text-danger" v-for="error of v$.template.redirectUrl.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="modal__action p-4">
      <button class="btn btn-outline-primary" style="text-transform:capitalize;" type="button" @click="saveTemplate" :disabled="saving">
        <div v-if="saving" class="spinner-border" role="status" style="height:15px; width:15px;">
          <span class="visually-hidden">Loading...</span>
        </div>
        {{buttonSave}}
      </button>
    </div>

</vue-final-modal>

    <!--end phishing dialog -->
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { debounce } from '@/plugins/helper.js'
import { required } from '@vuelidate/validators'
import FileUploader from '@/components/FileUploader.vue';
import ImageUploader from '@/components/ImageUploader.vue';
import Delete from '@/components/Delete.vue';
import Domain from '@/components/phishing/Domain.vue';


export default {
  name: "Phishing Template",

  components: {
      FileUploader,
      ImageUploader,
      Delete,
      Domain
   },


  setup() {
    return {
      v$: useVuelidate(),
    }
  },

  validations () {
    return {
      template: {
        name: {required},
        emailContent: {required},
        landingContent: {required},
        thumbnail: {required},
        linkToDomain: {required},
        redirectUrl: {required}
      },
    }
  },


  data() {
    return {
      loading: false,
      templateDialog: false,
      saving: false,
      search: "",
      view: {
        list: false,
        grid: true,
      },

      fileName: '',
      url: '',
      emailContentObject: null,
      thumbObject: null,
      isSelecting: false,
      landingName: '',
      landingContentObject: null,
      buttonSave: 'save',

      templates: [],
      template: {
        name: '',
        landingContent: null,
        emailContent: null,
        thumbnail: null,
        linkToDomain: '',
        redirectUrl: '',
      },

      sortBy: null,
      selectedSort: "Name",
      sortByOptions:[
        {
          label: "Name",
          value: "Name"
        },
        {
          label: "Created Date",
          value: "created_at"
        },
      ],
      thumbnailImageFile: null,
      onDelete: false,
      deleteID: 0,
      domainDialog: false,
      domains: [],
      orgID: this.$helper.setOrganisationID(),
    }
  },

  async created() {
    await this.getData();
    await this.getDomains();
  },

  methods: {
    getData() {
      this.loading = true;

      let params = {
        filter: this.search,
        sort: this.sortBy ? this.sortBy : ''
      }

      this.$axios.get('/supadmin/phishing-template', {params})
      .then((response) => {
          if (response.data.success){
            this.templates = response.data.templates;
          } else {
            this.$toast.error(response.data.message)
          }
        this.loading = false;
      })
      .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
    },

    getDomains() {
      this.$axios.get('/orgadmin/phishing-domain/' + this.orgID)
      .then((response) => {
          if (response.data.success){
            this.domains = response.data.domains;
          } else {
            this.$toast.error(response.data.message)
          }
        this.loading = false;
      })
      .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
    },


    setSelectedDomain() {
      // Find the domain object in the domains array that matches the selected linkToDomain
      const selectedDomainObj = this.domains.find(domain => domain.name === this.template.linkToDomain);
      if (selectedDomainObj) {
        this.template.linkToDomain = selectedDomainObj.name;
      }
    },

    setTemplate(item){
      this.id = item.ID;
      this.buttonSave = 'update';
      this.$axios.get("/supadmin/phishing-template/"+ item.ID)
      .then((response) => {
          if (response.data.success){
            this.templateDialog = true;
            this.template.name = response.data.template.name;

            this.template.emailContent = response.data.template.email_content;
            this.emailContentObject = response.data.template.email_content;

            this.template.landingContent = response.data.template.landing_page_content;
            this.landingContentObject = response.data.template.landing_page_content;

            this.thumbnailImageFile = response.data.template.thumbnail;
            this.template.thumbnail = response.data.template.thumbnail;
            this.template.linkToDomain = response.data.template.domain;
            this.template.redirectUrl = response.data.template.redirect_url;
            //find and match value of selected domain on edit
            this.setSelectedDomain();

            let tempEmailName = Buffer.from(response.data.template.email_content, 'base64').toString('utf-8');
            let tempLandingName = Buffer.from(response.data.template.landing_page_content, 'base64').toString('utf-8');
            this.fileName = tempEmailName.substring(0, 15)
            this.landingName = tempLandingName.substring(0, 15)
          } else
            this.$toast.error(response.data.message)
      })
      .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
    },

    handleEmailFileUpload({files}) {
      this.emailContentObject = files
      this.template.emailContent = files
    },

    handleLandingFileUpload({files}) {
      this.landingContentObject = files
      this.template.landingContent = files
    },

    handleThumbnailFileUpload({files}) {
      this.thumbObject = files
      this.template.thumbnail = files

    },

    async saveTemplate(){
      //touch inputs for validation
      this.v$.template.name.$touch();
      this.v$.template.emailContent.$touch();
      this.v$.template.landingContent.$touch();
      this.v$.template.thumbnail.$touch();
      this.v$.template.linkToDomain.$touch();
      this.v$.template.redirectUrl.$touch();

      //validate inputs
      if (this.v$.template.name.$invalid || this.v$.template.emailContent.$invalid || this.v$.template.landingContent.$invalid || this.v$.template.thumbnail.$invalid || this.v$.template.linkToDomain.$invalid || this.v$.template.redirectUrl.$invalid) return

      //change state
      this.saving = true;

      //append data to payloads
      let formData = new FormData();
        formData.append('name', this.template.name);

        if (this.emailContentObject != null)
          formData.append('email_template', this.emailContentObject);

        if (this.landingContentObject != null)
          formData.append('landing_template', this.landingContentObject);

        if (this.thumbObject != null)
          formData.append('thumbnail', this.thumbObject);

        formData.append('domain', this.template.linkToDomain);
        formData.append('redirect_url', this.template.redirectUrl);

      //check state if saving or not, save or update depending on state
      if (this.buttonSave == 'save'){
        this.$axios.post('/supadmin/phishing-template', formData)
        .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
            this.getData();

            this.closeDialog();
            this.saving = false;
          }
          else{
            this.$toast.error(response.data.message)
            this.saving = false;
          }

        })
        .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
      } else {
        this.$axios.put('/supadmin/phishing-template/' + this.id, formData)
        .then((response) => {
          if (response.data.success){
            this.getData();
            this.$toast.success(response.data.message)

            this.closeDialog();
            this.saving = false;
          }
          else{
            this.$toast.error(response.data.message)
            this.saving = false;
          }
        })
        .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
      }
    },

    closeDialog(){
      this.id = "";
      this.templateDialog = false;
      this.template = {
        name: '',
        emailContent: null,
        thumbnail: null,
        linkToDomain: '',
      };
      this.buttonSave = 'save';
      this.fileName = '';
      this.emailContentObject = null;
      this.thumbName = '';
      this.thumbObject = null;
      this.thumbnailImageFile = null;
      this.v$.$reset();
    },

    deleteTemplate(id) {
      this.onDelete = true;
      this.deleteID = id;
    },

    deleteConfirmation(value) {
      if (value.delete) {
        this.$axios.delete('/supadmin/phishing-template/' + value.id)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message)
                  this.getData();
              } else {
                  this.$toast.error(response.data.message)
              }
          })
          .catch(error => {
          const errorMessage = this.$helper.getErrorMessage(error);

          this.$toast.error(errorMessage);
          this.saving = false;
        });
        }
      this.onDelete = false;
      this.deleteID = 0;

    },

    closeConfirmation(){
      this.onDelete = false;
      this.deleteID = 0;
    },

    async closeDomainDialog() {
      await this.getData();
      await this.getDomains();
      this.domainDialog = false;
    }
  },

  computed: {
    emailButtonText() {
      return this.fileName ? this.fileName : 'Select Email Content';
    },

  },

  watch: {
    search: debounce(function() {
      this.templates = []
      this.getData()
    }, 600),

    sortBy(){
      this.getData();
    },

    organisation(){
      if (this.$store.state.auth.accessToken == null) return
      this.orgID = this.$store.state.user.organisation.id
      this.init();
    }
  }

}
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 10px;
          border-radius: 10px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
   font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
      font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
      font-size: 14px!important;
}

.video {
  width:100%;
}

/* buttons override */
.btn-circle-danger {
	width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

 .btn-circle-danger:hover {
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.btn-circle-danger:focus{
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.text-default{
	color: #435666;
}

div.inline { float:left;}

.form-check-input:checked {
  background-color: #00a0c1;
  border-color: #00d3fd;
}

td {
  white-space: normal !important;
  word-wrap: break-word;
}

table {
  table-layout: fixed;
}


.form-control::placeholder {
    color: #555555;
  }

@media screen and (max-width: 900px) {

:deep(.modal-content) {
  width: 95%;
}
}

/* custom icons
/* Common styles for icons */
.custom-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; /* Remove padding to avoid extra spacing */
  border-radius: 50%; /* Make the button round */
}

.custom-icon-btn svg {
  width: 20px;
  height: 20px;
}

/* Adjust the size of the edit icon */
.custom-icon-btn i.fa-pen {
  font-size: 14px;
}

/* The container holding all buttons */
.inline-block {
  display: flex;
  align-items: center; /* Vertically center the items */
  flex-wrap: wrap; /* Allow icons to wrap to the next line */
  gap: 5px; /* Add some spacing between the stacked icons */
}

/* Custom slider styles */
.custom-slider {
  position: relative;
  width: 42px;
  height: 22px;
  margin-right: 5px; /* Add some space between the slider and other icons */
}

.custom-slider .slider {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 40px; /* Adjust the width of the slider background */
  height: 20px; /* Adjust the height of the slider background */
  background-color: #B5DAC6;
  border-radius: 11px;
  cursor: pointer;
  transition: 0.4s;
}

.custom-slider .slider-button {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 20px; /* Adjust the width of the slider button */
  height: 20px; /* Adjust the height of the slider button */
  background-color: #00B972; /* Slightly different shade of green */
  border-radius: 50%;
  transition: 0.4s;
}

/* Move the slider button when it's checked (toggled on) */
.form-check-input:checked + .slider .slider-button {
  transform: translateX(20px);
}

/* Adjust the background color when the slider is toggled off (unchecked) */
.form-check-input:not(:checked) + .slider {
  background-color: #DADADA; /* A slightly grayer color */
}

/* Hide the default checkbox input */
.form-check-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Media Query for smaller screen sizes */
@media screen and (max-width: 768px) {
  .inline-block {
    flex-wrap: wrap; /* Allow icons to wrap to the next line */
  }

  .custom-icon-btn i.fa-pen {
    font-size: 16px; /* Adjust the size as needed */
  }

  /* Adjust the size of the slider button for smaller screens */
  .custom-slider .slider-button {
    width: 18px;
    height: 18px;
  }

  /* Adjust the size of other icons for smaller screens */
  .custom-icon-btn svg {
    width: 14px;
    height: 14px;
  }
}
</style>